import React from "react";
import { Box } from "@mui/material";
import { colors, fonts, layout } from "../../theme/tokens";

const MissionVision = () => {
  return (
    <Box
      component="section"
      sx={{ py: "56px", px: { xs: "20px", md: "28px" } }}
    >
      <Box sx={{ maxWidth: layout.maxWidth, mx: "auto" }}>
        {/* Header */}
        <Box sx={{ textAlign: "center", mb: "38px" }}>
          <Box
            sx={{ display: "inline-flex", alignItems: "center", gap: "12px" }}
          >
            <Box
              sx={{ width: "26px", height: "2px", background: colors.amber }}
            />
            <Box
              sx={{
                fontFamily: fonts.display,
                fontSize: "12.5px",
                fontWeight: 600,
                letterSpacing: ".2em",
                color: colors.steelBlue,
              }}
            >
              PURPOSE & DIRECTION
            </Box>
            <Box
              sx={{ width: "26px", height: "2px", background: colors.amber }}
            />
          </Box>
          <Box
            component="h2"
            sx={{
              fontFamily: fonts.display,
              fontWeight: 700,
              fontSize: "clamp(28px,3.4vw,42px)",
              lineHeight: 1.1,
              color: colors.navyInk,
              mt: "16px",
              mb: 0,
            }}
          >
            Mission & Vision
          </Box>
        </Box>

        {/* Cards */}
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
            gap: "18px",
          }}
        >
          {/* Mission — navy */}
          <Box
            sx={{
              background: "linear-gradient(160deg,#1E3A57,#0E1B2A)",
              borderRadius: "24px",
              p: { xs: "34px 30px", md: "42px 40px" },
              position: "relative",
              overflow: "hidden",
            }}
          >
            <Box
              sx={{
                position: "absolute",
                top: "-50px",
                right: "-30px",
                width: "200px",
                height: "200px",
                borderRadius: "50%",
                background:
                  "radial-gradient(circle,rgba(246,166,35,.18),transparent 65%)",
              }}
            />
            <Box
              sx={{
                width: "50px",
                height: "50px",
                borderRadius: "14px",
                background: "rgba(246,166,35,.16)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <circle
                  cx="12"
                  cy="12"
                  r="9"
                  stroke={colors.amberDot}
                  strokeWidth="2"
                />
                <circle
                  cx="12"
                  cy="12"
                  r="4"
                  stroke={colors.amberDot}
                  strokeWidth="2"
                />
                <circle cx="12" cy="12" r="1" fill={colors.amberDot} />
              </svg>
            </Box>
            <Box
              component="h3"
              sx={{
                fontFamily: fonts.display,
                fontWeight: 700,
                fontSize: "22px",
                color: "#fff",
                mt: "22px",
                mb: 0,
              }}
            >
              Our Mission
            </Box>
            <Box
              sx={{
                fontFamily: fonts.body,
                fontSize: "16px",
                lineHeight: 1.7,
                color: "#A9BACD",
                mt: "12px",
              }}
            >
              To be the best in everything we do, applying our experience and
              industry knowledge to create value for our clients.
            </Box>
          </Box>

          {/* Vision — white */}
          <Box
            sx={{
              background: "#fff",
              border: `1px solid ${colors.lineSoft}`,
              borderRadius: "24px",
              p: { xs: "34px 30px", md: "42px 40px" },
              boxShadow: "0 18px 40px -30px rgba(14,27,42,.5)",
            }}
          >
            <Box
              sx={{
                width: "50px",
                height: "50px",
                borderRadius: "14px",
                background: "#EAF1F8",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path
                  d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7Z"
                  stroke={colors.steelBlue}
                  strokeWidth="2"
                />
                <circle
                  cx="12"
                  cy="12"
                  r="3"
                  stroke={colors.steelBlue}
                  strokeWidth="2"
                />
              </svg>
            </Box>
            <Box
              component="h3"
              sx={{
                fontFamily: fonts.display,
                fontWeight: 700,
                fontSize: "22px",
                color: colors.navyInk,
                mt: "22px",
                mb: 0,
              }}
            >
              Our Vision
            </Box>
            <Box
              sx={{
                fontFamily: fonts.body,
                fontSize: "16px",
                lineHeight: 1.7,
                color: colors.mutedText,
                mt: "12px",
              }}
            >
              To provide professional services that help our clients add value,
              improve performance, and secure sustainability.
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default MissionVision;
